var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleChildren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1844.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Children",
    transform: "translate(2352.000000, 1844.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,15 C23.75,15 23.062,15.244 22.492,15.646 L21.975,16 C20.306,17.25 18.241,18 16,18 C13.759,18 11.695,17.25 10.025,16 L9.499,15.639 C8.931,15.24 8.246,15 7.5,15 C5.567,15 4,16.567 4,18.5 C4,19.955 4.896,21.181 6.161,21.705 C6.728,21.909 7.246,21.978 7.741,22.053 C7.811,22.062 7.878,22.076 7.948,22.088 C8.026,22.101 8.105,22.114 8.183,22.13 C8.269,22.146 8.354,22.164 8.438,22.185 C8.5,22.199 8.56,22.219 8.621,22.236 C11.143,22.945 13,25.255 13,28 L13,32 L19,32 L19,28 C19,25.357 20.719,23.112 23.097,22.315 L23.098,22.315 C23.254,22.259 23.411,22.219 23.569,22.183 C23.646,22.163 23.725,22.148 23.802,22.132 L23.869,22.12 C24.013,22.093 24.157,22.066 24.304,22.05 C24.89,21.961 25.51,21.869 26.207,21.539 C27.275,20.944 28,19.812 28,18.5 C28,16.567 26.433,15 24.5,15 M8.113,6.712 C8.045,7.132 8,7.561 8,8 C8,12.418 11.582,16 16,16 C20.418,16 24,12.418 24,8 C24,7.561 23.955,7.132 23.887,6.712 C25.129,6.174 26,4.94 26,3.5 C26,1.567 24.433,0 22.5,0 C21.512,0 20.624,0.413 19.987,1.071 C18.813,0.394 17.453,0 16,0 C14.546,0 13.187,0.394 12.013,1.071 C11.376,0.413 10.488,0 9.5,0 C7.567,0 6,1.567 6,3.5 C6,4.94 6.871,6.174 8.113,6.712 M25,24 C22.791,24 21,25.791 21,28 L21,32 L24.827,32 L25,32 C27.209,32 29,30.209 29,28 C29,25.791 27.209,24 25,24 M11,28 L11,32 L7.172,32 L7,32 C4.791,32 3,30.209 3,28 C3,25.791 4.791,24 7,24 C9.209,24 11,25.791 11,28",
    id: 49
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleChildren);
export default __webpack_public_path__ + "static/media/life-and-people-children.a74f5fe6.svg";
export { ForwardRef as ReactComponent };